import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { request } from '../../services/api';
import LogoutButton from '../../components/common/LogoutButton';
import { GiGreenhouse } from "react-icons/gi";
import { FaThermometerHalf, FaTint, FaWind, FaRedo } from "react-icons/fa"; // آیکون رفرش
import styles from './Dashboard.module.css';
import { CircuitBackgroundLayer } from "../../components/CircuitBackground/AnimatedCircuitChipBackground";
import { useLiveSensors } from '../../hooks/useLiveSensors'; // هوک وب‌سوکت

// --- تنظیمات رنگ و متن وضعیت‌ها ---
const getStatusConfig = (status) => {
  switch (status) {
    case 'online':
      return { color: '#52ae47', text: 'آنلاین (زنده)', dotAnim: true };
    case 'connecting':
      return { color: '#f59f00', text: 'در حال اتصال...', dotAnim: true }; // زرد
    case 'offline':
      return { color: '#ff4d4d', text: 'آفلاین (قطع)', dotAnim: false }; // قرمز
    case 'suspended':
      return { color: '#718096', text: 'توقف تلاش (قطع)', dotAnim: false }; // خاکستری
    default:
      return { color: '#718096', text: 'نامشخص', dotAnim: false };
  }
};

// --- کامپوننت کارت دستگاه (جدا شده برای مدیریت هوک هر دستگاه) ---
const DeviceCard = ({ device, onClick }) => {
  // دریافت دیتای زنده و وضعیت از هوک اختصاصی
  const { sensors, status, manualRetry } = useLiveSensors(device.device_serial);
  
  const statusConfig = getStatusConfig(status);
  const isSuspended = status === 'suspended';
  const isOffline = status === 'offline';

  // هندل کردن دکمه تلاش مجدد (جلوگیری از کلیک روی خود کارت)
  const handleRetryClick = (e) => {
    e.stopPropagation();
    if (manualRetry) manualRetry();
  };

  return (
    <div className={styles.card} onClick={onClick}>
      <GiGreenhouse className={styles.cardIcon} />
      
      <div className={styles.cardContent}>
        <h3 className={styles.deviceName}>{device.device_name}</h3>
        <div style={{color: '#e0e0e0', fontSize: '13px', marginBottom: '15px', opacity: 0.8}}>
           سریال: {device.device_serial}
        </div>

        {/* بخش نمایش سنسورها */}
        {/* اگر قطع یا تعلیق باشد، کمرنگ و سیاه و سفید می‌شود */}
        <div 
          className={styles.sensorSection}
          style={{ 
            opacity: isSuspended || isOffline ? 0.5 : 1, 
            filter: isSuspended ? 'grayscale(100%)' : 'none',
            transition: 'all 0.3s ease'
          }}
        >
          
          {/* 1. ردیف دما */}
          <div className={`${styles.sensorRow} ${styles.tempRow}`}>
            <div className={styles.rowIcon}>
              <FaThermometerHalf />
            </div>
            <div className={styles.dataStrip}>
              {sensors.temps.map((s, index) => (
                <div key={index} className={styles.sensorUnit}>
                  <span className={styles.sensorIndex}>{index}</span>
                  <span className={styles.sensorVal} style={{color: s.triggered ? '#ff4d4d' : '#fff'}}>
                     {s.value}
                  </span>
                  <span className={styles.sensorSet}>{s.setpoint}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 2. ردیف رطوبت */}
          <div className={`${styles.sensorRow} ${styles.humidRow}`}>
            <div className={styles.rowIcon}>
              <FaTint />
            </div>
            <div className={styles.dataStrip}>
              {sensors.humidity.map((s, index) => (
                <div key={index} className={styles.sensorUnit}>
                  <span className={styles.sensorIndex}>{index}</span>
                  <span className={styles.sensorVal} style={{color: s.triggered ? '#ff4d4d' : '#fff'}}>
                    {s.value}
                  </span>
                  <span className={styles.sensorSet}>{s.setpoint}</span>
                </div>
              ))}
            </div>
          </div>

          {/* 3. ردیف باد */}
          <div className={`${styles.sensorRow} ${styles.windRow}`}>
             <div className={styles.rowIcon}>
                <FaWind />
              </div>
              <div className={styles.dataStrip}>
                  <div className={styles.sensorUnit} style={{borderLeft: 'none', alignItems: 'flex-start', paddingRight: '10px'}}>
                      <div style={{display:'flex', alignItems:'baseline', gap:'5px'}}>
                        <span className={styles.sensorVal} style={{fontSize: '14px', color: sensors.wind.triggered ? '#ff4d4d' : '#fff'}}>
                          {sensors.wind.value} <small style={{fontSize:'9px', fontWeight:400}}>km/h</small>
                        </span>
                      </div>
                      <span className={styles.sensorSet}>حد: {sensors.wind.setpoint}</span>
                  </div>
              </div>
          </div>

        </div>

        {/* فوتر وضعیت + دکمه تلاش مجدد */}
        <div style={{marginTop: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: '28px'}}>
            <div style={{display: 'flex', alignItems: 'center', gap: '6px'}}>
                <span 
                    className={statusConfig.dotAnim ? styles.statusDot : ''} 
                    style={{
                        backgroundColor: statusConfig.color,
                        boxShadow: statusConfig.dotAnim ? `0 0 0 rgba(255,255,255,0.4)` : 'none',
                        width: '10px', height: '10px', borderRadius: '50%', display: 'inline-block'
                    }}
                ></span>
                <span style={{fontSize: '12px', color: statusConfig.color, fontWeight: 'bold'}}>
                    {statusConfig.text}
                </span>
            </div>

            {/* نمایش دکمه رفرش فقط وقتی suspended شده */}
            {isSuspended && (
                <button 
                  onClick={handleRetryClick} 
                  className={styles.retryBtn} 
                  title="تلاش مجدد برای اتصال"
                >
                    <FaRedo />
                </button>
            )}
        </div>
      </div>
    </div>
  );
};

// --- کامپوننت اصلی صفحه ---
const DashboardPage = () => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchDevices = async () => {
      try {
        // دریافت لیست دستگاه‌ها از دیتابیس (فقط نام و سریال)
        const data = await request('/get_devices.php');
        if (data.status === 'success') {
          setDevices(data.devices);
        }
      } catch (error) {
        console.error("Error fetching devices:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDevices();
  }, []);

  const handleCardClick = (deviceId) => {
    navigate(`/monitor/${deviceId}`);
  };

  if (loading) return (
    <div className={styles.loadingContainer}>
      در حال دریافت لیست دستگاه‌ها...
    </div>
  );

  return (
    <div className={styles.container}>
      <CircuitBackgroundLayer />
      <div className={styles.overlay}></div>
       
      <div className={styles.content}>
        
        <header className={styles.header}>
          <div className={styles.headerContent}>
            <h2 className={styles.title}>داشبورد گلخانه هوشمند</h2>
            <LogoutButton className={styles.logoutBtn} />
          </div>
        </header>

        <div className={styles.gridWrapper}>
          {devices.length === 0 ? (
            <div className={styles.emptyState}>
               <p>هیچ دستگاهی یافت نشد.</p>
               <small>لطفاً اتصال دیتابیس را بررسی کنید.</small>
            </div>
          ) : (
            <div className={styles.grid}>
              {devices.map((device) => (
                <DeviceCard 
                  key={device.id} 
                  device={device} 
                  onClick={() => handleCardClick(device.id)} 
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;